import { useState, MouseEvent } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
} from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
//interface describing props exported from config
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RouteItem from "../routes/index";
import { useNavigate } from "react-router-dom";

//setting incoming props default type to RouteItem pre-defined interface
interface InputProps {
  key: string | null | undefined;
  menuItem: RouteItem;
  currentPath: string | null;
  parentPath: string;
  setCurrentPath?: Function;
  setParentPath?: Function;
  setMobileHamburgerState?: Function;
}
export default function SubMenu({
  key,
  menuItem,
  currentPath,
  parentPath,
  setCurrentPath,
  setParentPath,
  setMobileHamburgerState,
}: InputProps) {
  const navigate = useNavigate();
  //variables declaration
  let currentlyHovering: boolean = false;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  //Logic Of Opening And CLosing Menus on Click
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //Logic Of Opening And CLosing Menus on Hover
  const handleHover = () => {
    currentlyHovering = true;
  };

  const handleCloseHover = () => {
    currentlyHovering = false;
    setTimeout(() => {
      if (!currentlyHovering) {
        handleClose();
      }
    }, 50);
  };

  return (
    <Box>
      <Accordion
        elevation={0}
        sx={{
          display: {
            xs: "flex",
            md: "none",
          },
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          width: "100% !important",
          minWidth: "100vw !important",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          sx={{
            padding: 0,
            fontSize: "0.7rem",
            fontWeight: "bold",
            width: "fit-content",
            fontFamily: "inherit",
          }}
        >
          {menuItem.title}
        </AccordionSummary>
        <AccordionDetails>
          {menuItem?.subRoutes?.map((subMenu: RouteItem) => (
            <Stack
              direction={{ xs: "column" }}
              alignItems={{ xs: "center" }}
              key={subMenu.key}
            >
              <Button
                onClick={() => {
                  setMobileHamburgerState && setMobileHamburgerState(false);
                  setCurrentPath && setCurrentPath(subMenu.path);
                  setParentPath && setParentPath(menuItem.path);
                  navigate(menuItem.path + "/" + subMenu.path);
                }}
                sx={{
                  fontFamily: "inherit",
                  color:
                    currentPath === subMenu.path ? "secondary.light" : "black",
                  bgcolor: currentPath === subMenu.path ? "primary.main" : "",
                  ":hover": {
                    bgcolor: "primary.main", // theme.palette.primary.main
                    color: "secondary.light",
                  },
                  width: { xs: "100%" },
                }}
              >
                {subMenu.title}
              </Button>
            </Stack>
          ))}
        </AccordionDetails>
      </Accordion>
      <Button
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        // onMouseOver={handleClick}
        // onMouseOut={handleCloseHover}
        sx={{
          //fontWeight: "bold",
          fontFamily: "inherit",
          textWrap: "nowrap",
          color:
            parentPath === menuItem.path
              ? "customColors.clr1"
              : "text.secondary",
          bgcolor: parentPath === menuItem.path ? "customColors.clr2" : "",
          ":hover": {
            bgcolor: "customColors.clr2", // theme.palette.primary.main
            color: "customColors.clr1",
          },
          display: { xs: "none", md: "flex" },
        }}
        endIcon={open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      >
        {menuItem.title}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          // onMouseEnter: handleHover,
          // onMouseLeave: handleCloseHover,
          style: { pointerEvents: "auto" },
        }}
      >
        {menuItem?.subRoutes?.map((subMenu: RouteItem) => (
          <MenuItem
            key={subMenu.key}
            onClick={() => {
              handleClose();
              setCurrentPath && setCurrentPath(subMenu.path);
              setParentPath && setParentPath(menuItem.path);
              navigate(menuItem.path + "/" + subMenu.path);
            }}
            sx={{
              color:
                currentPath === subMenu.path
                  ? "customColors.clr1"
                  : "text.secondary",
              fontFamily: "inherit",
              bgcolor: currentPath === subMenu.path ? "customColors.clr2" : "",
              ":hover": {
                // theme.palette.primary.main
                bgcolor: "customColors.clr2",
                color: "customColors.clr1",
              },
              width: { xs: "100%" },
            }}
          >
            {subMenu.title}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
